import React from 'react';
import './Buttons.scss';
import PrevContainer from "./prev/PrevContainer";
import NextContainer from "./next/NextContainer";
import ClearContainer from "./clear/ClearContainer";
import Choices from "./choices/ChoicesContainer";
import ConfirmContainer from "./confirm/ConfirmContainer";

const Buttons = props => {
  return (
    <div className='remote-buttons'>
      <div className="remote-buttons__btn-prev-next-container">
        <PrevContainer/>
        <NextContainer/>
      </div>
      <ClearContainer/>
      <Choices/>
      <ConfirmContainer/>
    </div>
  );
};

export default Buttons;
